import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { defaultTheme } from '../../config/theming';

const Button = styled.button`
  height: 45px;
  width: 131px;
  border: none;
  background-color: ${defaultTheme.colors.error};
  color: #fff;
  padding: 3px;
  box-shadow: 0px 2px 7px ${defaultTheme.colors.error};
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    background-color: #eb132c;
  }
  &:focus {
    background-color: #eb132c;
    box-shadow: 0px 2px 7px #eb132c;
  }
  &:active {
    background-color: #eb132c;
    box-shadow: none;
  }
  &:disabled {
    background-color: #e4e4e4;
    color: #aaaaaa;
    border-color: #e4e4e4;
    box-shadow: none;
    cursor: not-allowed;
  }
`;

interface Props {
  disabled?: boolean;
  clickFn: () => void;
  children: ReactNode;
  testId?: string;
}

export const DangerButton = (props: Props) => {
  return (
    <Button data-testid={props.testId} disabled={props.disabled} onClick={props.clickFn}>
      {props.children}
    </Button>
  );
};

export default DangerButton;
